module.exports = __webpack_public_path__ + "img/icon_batch.c11581a5.png";